module.exports = __webpack_public_path__ + "static/media/29COICT8.ed8dd4f3.jpg";